exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-button--text[data-v-059037f9] {\n  padding: 0 !important;\n  width: auto !important;\n  margin-left: 5px !important;\n}\n.el-button--text span[data-v-059037f9] {\n  margin-left: 0px !important;\n}\n", ""]);

// exports
